import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/img/cross.svg'


const _hoisted_1 = { class: "opModal formContainer" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "body" }
const _hoisted_7 = { class: "mt-4" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "col-sm-6" }
const _hoisted_10 = { class: "col-sm-6" }
const _hoisted_11 = { class: "text-center mt-5" }
const _hoisted_12 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_form_field = _resolveComponent("form-field")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_localized_text, {
          localizedKey: "Edit WattMin",
          text: "Edit WattMin"
        })
      ]),
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-modal-close",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
      }, _hoisted_5)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_form_field, {
              type: "text",
              labelKey: "Watt Label",
              labelValue: "Watt Label",
              placeholderKey: "Watt Label",
              placeholderValue: "Watt Label",
              modelValue: _ctx.localModel.watt.key,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.localModel.watt.key) = $event))
            }, null, 8, ["modelValue"]),
            _createVNode(_component_form_field, {
              type: "text",
              labelKey: "Minutes Label",
              labelValue: "Minutes Label",
              placeholderKey: "Minutes Label",
              placeholderValue: "Minutes Label",
              modelValue: _ctx.localModel.minutes.key,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.localModel.minutes.key) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_form_field, {
              type: "number",
              labelKey: "Watt Value",
              labelValue: "Watt Value",
              placeholderKey: "Watt Value",
              placeholderValue: "Watt Value",
              modelValue: _ctx.localModel.watt.value,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.localModel.watt.value) = $event))
            }, null, 8, ["modelValue"]),
            _createVNode(_component_form_field, {
              type: "number",
              labelKey: "Minutes Value",
              labelValue: "Minutes Value",
              placeholderKey: "Minutes Value",
              placeholderValue: "Minutes Value",
              modelValue: _ctx.localModel.minutes.value,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.localModel.minutes.value) = $event))
            }, null, 8, ["modelValue"])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-tertiary",
          disabled: !_ctx.canSave,
          onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.save && _ctx.save(...args)))
        }, [
          _createVNode(_component_localized_text, {
            localizedKey: "Save",
            text: "Save"
          })
        ], 8, _hoisted_12)
      ])
    ])
  ]))
}